import {
  get,
  getAsync,
  post,
  postAsync,
  put,
  putAsync,
  del,
  deleteAsync,
  getAuthorizationHeader,
  hasInitialisedToken,
  ContentTypeEnum,
} from "./apiCallerHelper.core";

export async function statsFilter({
  startDate,
  endDate,
  receiverKind,
  receiverName,
  instanceStep,
  energyKind,
  instanceCategory,
  instanceSubject,
  senderAccept,
  pendingInstances,
  responseTime,
  InTime,
  isPendingChecked
}) {
  var route = "/api/parameter_stats/statsfilter/";
  let data = { 
    startDate: startDate,
    endDate: endDate,
    receiverKind: receiverKind,
    receiverName: receiverName,
    // 'instanceStatus': this.state.instanceStatus,
    instanceStep: instanceStep,
    energyKind: energyKind,
    instanceCategory: instanceCategory,
    instanceSubject: instanceSubject,
    senderAccept: senderAccept,
    pendingInstances: pendingInstances,
    responseTime: responseTime,
    // 'declinedBy': this.state.declinedBy,
    InTime: InTime,
    isPendingChecked: isPendingChecked

  };
  let asyncResult = await postAsync(route, data);
  return asyncResult;
}